import { CvSectionConfigDTO } from './cv-section-config-dto';

export enum FileType {
    rtf = 'RTF',
    doc = 'DOC',
}

export interface CvRequestParams {
    userId: string;
    sectionList: CvSectionConfigDTO[];
    fileType: FileType;
    fileName: string;
    language: string;
}
